function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42.601 53.36l21.113-21.112a1 1 0 011.707.707v46.427H76V31.556c0-6.075-4.925-11-11-11a11 11 0 00-7.778 3.222L35.196 45.804l-3.53-5.105a2 2 0 00-3.612.777l-4.116 22.416a1 1 0 001.164 1.164l22.43-4.119a2 2 0 00.78-3.61l-5.71-3.967z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-turn-sharply-left.svg";